/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { UserModelEditorViewModel } from '../models/user-model-editor-view-model';
import { UserModel } from '../models/user-model';
import { RoleQueryResponseModel } from '../models/role-query-response-model';
import { LoginInformationModel } from '../models/login-information-model';
import { UserQueryResponseModel } from '../models/user-query-response-model';
import { UserModelListEditorViewModel } from '../models/user-model-list-editor-view-model';
import { UserModelImportModel } from '../models/user-model-import-model';
@Injectable({
  providedIn: 'root',
})
class UserService extends __BaseService {
  static readonly AddRolePath = '/view/ndms/user/{userKey}/AddRole';
  static readonly GetPath = '/view/ndms/user';
  static readonly GetByKeyPath = '/view/ndms/user/{userKey}';
  static readonly SavePath = '/view/ndms/user/{userKey}';
  static readonly GetAllRolesPath = '/view/ndms/user/AllRoles';
  static readonly GetCurrentPath = '/view/ndms/user/GetCurrent';
  static readonly GetLoginInformationPath = '/view/ndms/user/GetLoginInformation';
  static readonly QueryPath = '/view/ndms/user/Query';
  static readonly RemoveRolePath = '/view/ndms/user/{userKey}/RemoveRole';
  static readonly SaveCurrentPath = '/view/ndms/user/SaveCurrent';
  static readonly UploadPath = '/view/ndms/user/upload';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `UserService.AddRoleParams` containing the following parameters:
   *
   * - `userKey`:
   *
   * - `RoleName`:
   *
   * - `RoleKey`:
   *
   * - `DisplayName`:
   *
   * @return Success
   */
  AddRoleResponse(params: UserService.AddRoleParams): __Observable<__StrictHttpResponse<UserModelEditorViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.RoleName != null) __params = __params.set('RoleName', params.RoleName.toString());
    if (params.RoleKey != null) __params = __params.set('RoleKey', params.RoleKey.toString());
    if (params.DisplayName != null) __params = __params.set('DisplayName', params.DisplayName.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/ndms/user/${params.userKey}/AddRole`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserModelEditorViewModel>;
      })
    );
  }
  /**
   * @param params The `UserService.AddRoleParams` containing the following parameters:
   *
   * - `userKey`:
   *
   * - `RoleName`:
   *
   * - `RoleKey`:
   *
   * - `DisplayName`:
   *
   * @return Success
   */
  AddRole(params: UserService.AddRoleParams): __Observable<UserModelEditorViewModel> {
    return this.AddRoleResponse(params).pipe(
      __map(_r => _r.body as UserModelEditorViewModel)
    );
  }

  /**
   * @return Success
   */
  GetResponse(): __Observable<__StrictHttpResponse<UserModelEditorViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/ndms/user`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserModelEditorViewModel>;
      })
    );
  }
  /**
   * @return Success
   */
  Get(): __Observable<UserModelEditorViewModel> {
    return this.GetResponse().pipe(
      __map(_r => _r.body as UserModelEditorViewModel)
    );
  }

  /**
   * @param userKey undefined
   * @return Success
   */
  GetByKeyResponse(userKey: string): __Observable<__StrictHttpResponse<UserModelEditorViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/ndms/user/${userKey}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserModelEditorViewModel>;
      })
    );
  }
  /**
   * @param userKey undefined
   * @return Success
   */
  GetByKey(userKey: string): __Observable<UserModelEditorViewModel> {
    return this.GetByKeyResponse(userKey).pipe(
      __map(_r => _r.body as UserModelEditorViewModel)
    );
  }

  /**
   * @param params The `UserService.SaveParams` containing the following parameters:
   *
   * - `userModel`:
   *
   * - `userKey`:
   *
   * @return Success
   */
  SaveResponse(params: UserService.SaveParams): __Observable<__StrictHttpResponse<UserModelEditorViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.userModel;
    if (params.userKey != null) __params = __params.set('userKey', params.userKey.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/ndms/user/${params.userKey}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserModelEditorViewModel>;
      })
    );
  }
  /**
   * @param params The `UserService.SaveParams` containing the following parameters:
   *
   * - `userModel`:
   *
   * - `userKey`:
   *
   * @return Success
   */
  Save(params: UserService.SaveParams): __Observable<UserModelEditorViewModel> {
    return this.SaveResponse(params).pipe(
      __map(_r => _r.body as UserModelEditorViewModel)
    );
  }

  /**
   * @return Success
   */
  GetAllRolesResponse(): __Observable<__StrictHttpResponse<RoleQueryResponseModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/ndms/user/AllRoles`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<RoleQueryResponseModel>;
      })
    );
  }
  /**
   * @return Success
   */
  GetAllRoles(): __Observable<RoleQueryResponseModel> {
    return this.GetAllRolesResponse().pipe(
      __map(_r => _r.body as RoleQueryResponseModel)
    );
  }

  /**
   * @return Success
   */
  GetCurrentResponse(): __Observable<__StrictHttpResponse<UserModelEditorViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/ndms/user/GetCurrent`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserModelEditorViewModel>;
      })
    );
  }
  /**
   * @return Success
   */
  GetCurrent(): __Observable<UserModelEditorViewModel> {
    return this.GetCurrentResponse().pipe(
      __map(_r => _r.body as UserModelEditorViewModel)
    );
  }

  /**
   * @return Success
   */
  GetLoginInformationResponse(): __Observable<__StrictHttpResponse<LoginInformationModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/ndms/user/GetLoginInformation`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<LoginInformationModel>;
      })
    );
  }
  /**
   * @return Success
   */
  GetLoginInformation(): __Observable<LoginInformationModel> {
    return this.GetLoginInformationResponse().pipe(
      __map(_r => _r.body as LoginInformationModel)
    );
  }

  /**
   * @param params The `UserService.QueryParams` containing the following parameters:
   *
   * - `UserName`:
   *
   * - `Take`:
   *
   * - `SortOrder`:
   *
   * - `SortBy`:
   *
   * - `Skip`:
   *
   * - `PageSize`:
   *
   * - `Page`:
   *
   * - `LastName`:
   *
   * - `ForExport`:
   *
   * - `FirstName`:
   *
   * - `AccountStatus`:
   *
   * @return Success
   */
  QueryResponse(params: UserService.QueryParams): __Observable<__StrictHttpResponse<UserQueryResponseModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.UserName != null) __params = __params.set('UserName', params.UserName.toString());
    if (params.Take != null) __params = __params.set('Take', params.Take.toString());
    if (params.SortOrder != null) __params = __params.set('SortOrder', params.SortOrder.toString());
    if (params.SortBy != null) __params = __params.set('SortBy', params.SortBy.toString());
    if (params.Skip != null) __params = __params.set('Skip', params.Skip.toString());
    if (params.PageSize != null) __params = __params.set('PageSize', params.PageSize.toString());
    if (params.Page != null) __params = __params.set('Page', params.Page.toString());
    if (params.LastName != null) __params = __params.set('LastName', params.LastName.toString());
    if (params.ForExport != null) __params = __params.set('ForExport', params.ForExport.toString());
    if (params.FirstName != null) __params = __params.set('FirstName', params.FirstName.toString());
    if (params.AccountStatus != null) __params = __params.set('AccountStatus', params.AccountStatus.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/ndms/user/Query`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserQueryResponseModel>;
      })
    );
  }
  /**
   * @param params The `UserService.QueryParams` containing the following parameters:
   *
   * - `UserName`:
   *
   * - `Take`:
   *
   * - `SortOrder`:
   *
   * - `SortBy`:
   *
   * - `Skip`:
   *
   * - `PageSize`:
   *
   * - `Page`:
   *
   * - `LastName`:
   *
   * - `ForExport`:
   *
   * - `FirstName`:
   *
   * - `AccountStatus`:
   *
   * @return Success
   */
  Query(params: UserService.QueryParams): __Observable<UserQueryResponseModel> {
    return this.QueryResponse(params).pipe(
      __map(_r => _r.body as UserQueryResponseModel)
    );
  }

  /**
   * @param params The `UserService.RemoveRoleParams` containing the following parameters:
   *
   * - `userKey`:
   *
   * - `RoleName`:
   *
   * - `RoleKey`:
   *
   * - `DisplayName`:
   *
   * @return Success
   */
  RemoveRoleResponse(params: UserService.RemoveRoleParams): __Observable<__StrictHttpResponse<UserModelEditorViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.RoleName != null) __params = __params.set('RoleName', params.RoleName.toString());
    if (params.RoleKey != null) __params = __params.set('RoleKey', params.RoleKey.toString());
    if (params.DisplayName != null) __params = __params.set('DisplayName', params.DisplayName.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/ndms/user/${params.userKey}/RemoveRole`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserModelEditorViewModel>;
      })
    );
  }
  /**
   * @param params The `UserService.RemoveRoleParams` containing the following parameters:
   *
   * - `userKey`:
   *
   * - `RoleName`:
   *
   * - `RoleKey`:
   *
   * - `DisplayName`:
   *
   * @return Success
   */
  RemoveRole(params: UserService.RemoveRoleParams): __Observable<UserModelEditorViewModel> {
    return this.RemoveRoleResponse(params).pipe(
      __map(_r => _r.body as UserModelEditorViewModel)
    );
  }

  /**
   * @param userModel undefined
   * @return Success
   */
  SaveCurrentResponse(userModel?: UserModel): __Observable<__StrictHttpResponse<UserModelEditorViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = userModel;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/ndms/user/SaveCurrent`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserModelEditorViewModel>;
      })
    );
  }
  /**
   * @param userModel undefined
   * @return Success
   */
  SaveCurrent(userModel?: UserModel): __Observable<UserModelEditorViewModel> {
    return this.SaveCurrentResponse(userModel).pipe(
      __map(_r => _r.body as UserModelEditorViewModel)
    );
  }

  /**
   * @param userModels undefined
   * @return Success
   */
  UploadResponse(userModels?: UserModelImportModel): __Observable<__StrictHttpResponse<UserModelListEditorViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = userModels;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/ndms/user/upload`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserModelListEditorViewModel>;
      })
    );
  }
  /**
   * @param userModels undefined
   * @return Success
   */
  Upload(userModels?: UserModelImportModel): __Observable<UserModelListEditorViewModel> {
    return this.UploadResponse(userModels).pipe(
      __map(_r => _r.body as UserModelListEditorViewModel)
    );
  }
}

module UserService {

  /**
   * Parameters for AddRole
   */
  export interface AddRoleParams {
    userKey: string;
    RoleName?: string;
    RoleKey?: string;
    DisplayName?: string;
  }

  /**
   * Parameters for Save
   */
  export interface SaveParams {
    userModel?: UserModel;
    userKey?: string;
  }

  /**
   * Parameters for Query
   */
  export interface QueryParams {
    UserName?: string;
    Take?: number;
    SortOrder?: number;
    SortBy?: string;
    Skip?: number;
    PageSize?: number;
    Page?: number;
    LastName?: string;
    ForExport?: boolean;
    FirstName?: string;
    AccountStatus?: number;
  }

  /**
   * Parameters for RemoveRole
   */
  export interface RemoveRoleParams {
    userKey: string;
    RoleName?: string;
    RoleKey?: string;
    DisplayName?: string;
  }
}

export { UserService }
